<template>
  <div>
    <div class="layout-header" ref="searchBox">
      <div class="infor-layout-header">
        <span class="title">车辆信息</span>
      </div>
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
        size="small">
        <el-form-item label="品牌名称">
          <el-select v-model="form.brandId" style="width: 120px">
            <el-option label="全部" value="all"></el-option>
            <el-option
              :label="item.value"
              :value="item.key"
              v-for="item in brands"
              :key="item.key"/>
          </el-select>
        </el-form-item>
        <el-form-item label="车辆编号">
          <el-input v-model="form.bikeId" style="width: 150px"/>
        </el-form-item>
        <el-form-item label="车辆类型">
          <el-select v-model="form.bikeType"  style="width: 100px" :disabled="disabled">
            <el-option
              :label="item.label"
              :value="item.key"
              v-for="item in bikeTypeOptions"
              :key="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车牌号">
          <el-input v-model="form.licenseCode" style="width: 150px"/>
        </el-form-item>
        <el-form-item label="入库时间">
          <el-date-picker
            v-model="form.dataRange"
            style="width: 230px"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="车辆合法性">
          <el-select v-model="form.legality"  style="width: 100px">
            <el-option
              :label="item.label"
              :value="item.key"
              v-for="item in legalityOptions"
              :key="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车辆状态">
          <el-select v-model="form.bikeStatus"  style="width: 100px">
            <el-option
              :label="item.label"
              :value="item.key"
              v-for="item in bikeStatusOptions"
              :key="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
          <el-button v-show="checkUserAuth(4, 221)" @click="onExportBtn">导出</el-button>
          <el-button v-show="checkUserAuth(4, 223)" @click="onBikeLogExport">导出车辆日志</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="height: 10.3125rem"></div>
    <div class="pagination-bg-white layout-header">
      <el-table
        v-show="checkUserAuth(4, 14)"
        v-loading.body="tableLoading"
        :data="tableData"
        :max-height="tableViewHeight"
        width="100%"
        @sort-change="handleSortChange"
        highlight-current-row>
        <el-table-column prop="index" label="序号" align="center">
          <template v-slot="props">
            <span>{{ props.$index + 1 + (formData.pageNum - 1) * formData.pageSize }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="brandName" label="品牌名称" align="center"></el-table-column>
        <el-table-column prop="bikeId" label="车辆编号" align="center"></el-table-column>
        <el-table-column prop="licenseCode" label="车牌号" align="center">
          <template v-slot="props">
            <span>{{props.row.licenseCode!=''?props.row.licenseCode:'-'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="frameCode" label="车架号" align="center">
          <template v-slot="props">
            <span>{{props.row.frameCode!=''?props.row.frameCode:'-'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="入库时间" sortable></el-table-column>                                                                                                                                                         align="center"></el-table-column>
        <el-table-column prop="legality" label="车辆合法性" align="center">
          <template v-slot="props">
            <span>{{props.row.legality | filterLegality}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bikeStatusName" label="车辆状态" align="center"></el-table-column>
        <el-table-column prop="rentNum" label="骑行次数" sortable align="center"></el-table-column>
        <el-table-column prop="dispatchNum" label="调度次数" sortable align="center"></el-table-column>
        <el-table-column prop="operationDays" label="运营天数" sortable align="center"></el-table-column>
        <el-table-column prop="bikeType" label="车辆类型" align="center">
          <template v-slot="props">
            <span>{{props.row.bikeType | filterBikeType}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 15px; text-align: right"
        @size-change="handleSizeChange"
        @current-change="pageNoChange"
        :current-page="formData.pageNum"
        :page-sizes="pageSizes"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
      <div v-show="!checkUserAuth(4, 216)">您的账户没有权限查看此内容！</div>
    </div>
    <!--导出车辆接口日志-->
    <w-dialog
      width="60%"
      ref="export-log"
      title="导出设置"
      sureBtnText="导出"
      @handleCloseRight="handleCloseExportLog"
      @handleClose="handleCloseExportLog"
      @onSure="onExportLog">
      <template v-slot:content>
        <el-form ref="form" :model="form" label-width="6.25rem">
          <el-form-item label="品牌选择：">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <el-checkbox-group v-model="checkedBrandIds" @change="handleCheckedCitiesChange">
              <el-checkbox :label="item.key" :key="item.key" v-for="item in brands">{{item.value}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="车辆合法性">
            <el-radio-group v-model="exportLegality">
              <el-radio :label="null">全部</el-radio>
              <el-radio :label="0">合法</el-radio>
              <el-radio :label="1">非法</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </template>
    </w-dialog>
  </div>
</template>

<script>
import Api from '@/api'
import { mapGetters } from 'vuex'
import { lookPDF } from '@/utils/tools'
import WDialog from '@/components/Model/index.vue'
export default {
  name: 'requestSync',
  components: {
    WDialog
  },
  data() {
    return {
      form: {
        brandId: 'all',
        bikeType: 'all',
        bikeStatus: 'all',
        legality: 'all',
        bikeId: '',
        licenseCode: '',
        dataRange: ''
      },
      bikeTypeOptions: [
        {
          key: 'all',
          label: '全部'
        }, {
          key: 0,
          label: '自行车'
        }, {
          key: 1,
          label: '电动车'
        }],
      legalityOptions: [
        {
          key: 'all',
          label: '全部'
        }, {
          key: '0',
          label: '合法性'
        }, {
          key: '1',
          label: '非法性'
        }],
      bikeStatusOptions: [
        {
          key: 'all',
          label: '全部'
        }, {
          key: 1,
          label: '停放中'
        }, {
          key: 2,
          label: '骑行中'
        }, {
          key: 3,
          label: '已回收'
        }],
      tableViewHeight: 50,
      columns: [
        {
          prop: 'index',
          label: '序号'
        }, {
          prop: 'brandName',
          label: '品牌名称'
        }, {
          prop: 'bikeId',
          label: '车辆编号'
        }, {
          prop: 'licenseCode',
          label: '车牌号'
        }, {
          prop: 'frameCode',
          label: '车架号'
        }, {
          prop: 'createTime',
          label: '入库时间'
        }, {
          prop: 'legality',
          label: '车辆合法性'
        }, {
          prop: 'bikeStatusName',
          label: '车辆状态'
        }, {
          prop: 'rentNum',
          label: '骑行次数'
        }, {
          prop: 'dispatchNum',
          label: '调度次数'
        }, {
          prop: 'operationDays',
          label: '运营天数'
        }, {
          prop: 'bikeType',
          label: '车辆类型'
        }
      ],
      tableLoading: true,
      tableData: [],
      formData: {
        pageNum: 1,
        pageSize: 20
      },
      total: 0,
      checkedBrandIds: [],
      checkAll: false, // 是否全选
      isIndeterminate: false, // 用以表示 checkbox 的不确定状态，一般用于实现全选的效果
      exportLegality: null,
      pageSizes: [10, 20, 50],
      orderBy: 'create_time asc',
      disabled: true
    }
  },
  computed: {
    ...mapGetters(['user', 'selfAreaId', 'brands','userBikeType'])
  },
  filters: {
    filterBrandName(value, brands) {
      return brands.some(item => String(item.brandId) === String(value))
        ? brands.find(item => String(item.brandId) === String(value)).brandName
        : undefined
    },
    filterLegality(value) {
      return {
        0: '合法性',
        1: '非法性'
      }[Number(value)]
    },
    filterBikeType(value) {
      return {
        0: '自行车',
        1: '电动车'
      }[Number(value)]
    }
  },
  created() {
    if (this.userBikeType === 2) {
      this.form.bikeType = 'all'
      this.disabled = false
    } else {
      this.form.bikeType = this.userBikeType
      this.disabled = true
    }
    this.onSearch()
  },
  methods: {
    onSearch() {
      this.tableLoading = true
      const params = {
        selfAreaId: this.selfAreaId,
        currentPage: this.formData.pageNum,
        pageSize: this.formData.pageSize,
        bikeId: this.form.bikeId,
        licenseCode: this.form.licenseCode,
        orderBy: this.orderBy
      }
      if (this.form.brandId !== 'all') {
        params.brandId = this.form.brandId
      }
      if (this.form.bikeType !== 'all') {
        params.bikeType = this.form.bikeType
      }
      if (this.form.bikeStatus !== 'all') {
        params.bikeStatus = this.form.bikeStatus
      }
      if (this.form.legality !== 'all') {
        params.legality = this.form.legality
      }
      if (this.form.dataRange) {
        // 获取开始时间和结束时间，并设置时分秒
        params.startTime = this.dayjs(this.form.dataRange[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
        params.endTime = this.dayjs(this.form.dataRange[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
      Api.getBikeSyncList(params).then((res) => {
        this.tableLoading = false
        if (res.code === 200 && res.data) {
          this.tableData = res.data.lists
          this.total = res.data.total
        } else {
          this.$message.warning(res.message)
        }
        this.calcView()
      })
    },
    pageNoChange(page) {
      this.formData.pageNum = page
      this.onSearch()
    },
    handleSizeChange(size) {
      this.formData.pageSize = size
      this.onSearch()
    },
    handleSortChange({ column, prop, order }) {
      if (order === 'ascending') {
        if (prop === 'createTime') {
          this.orderBy = 'create_time asc'
        } else if (prop === 'rentNum') {
          this.orderBy = 'rent_num asc'
        } else if (prop === 'dispatchNum') {
          this.orderBy = 'dispatch_num asc'
        } else {
          this.orderBy = 'operation_days asc'
        }
      } else {
        if (prop === 'createTime') {
          this.orderBy = 'create_time desc'
        } else if (prop === 'rentNum') {
          this.orderBy = 'rent_num desc'
        } else if (prop === 'dispatchNum') {
          this.orderBy = 'dispatch_num desc'
        } else {
          this.orderBy = 'operation_days desc'
        }
      }
      this.onSearch()
    },
    onReset() {
      this.form.brandId = 'all'
      this.form.bikeType = 'all'
      this.form.bikeStatus = 'all'
      this.form.legality = 'all'
      this.form.bikeId = ''
      this.form.licenseCode = ''
      this.form.dataRange = ''
      this.onSearch()
    },
    onExportBtn() {
      if (this.total > 0) {
        this.onSureExport()
      } else {
        this.$confirm('导出数据为空，是否确认导出?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.onSureExport()
        }).catch(() => {
          console.log('已取消导出车辆信息列表数据')
        })
      }
    },
    onSureExport() {
      const params = {
        selfAreaId: this.selfAreaId,
        currentPage: this.formData.pageNum,
        pageSize: this.formData.pageSize,
        bikeId: this.form.bikeId,
        licenseCode: this.form.licenseCode,
        orderBy: this.orderBy
      }
      if (this.form.brandId !== 'all') {
        params.brandId = this.form.brandId
      }
      if (this.form.bikeType !== 'all') {
        params.bikeType = this.form.bikeType
      }
      if (this.form.bikeStatus !== 'all') {
        params.bikeStatus = this.form.bikeStatus
      }
      if (this.form.legality !== 'all') {
        params.legality = this.form.legality
      }
      if (this.form.dataRange) {
        // 获取开始时间和结束时间，并设置时分秒
        params.startTime = this.dayjs(this.form.dataRange[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
        params.endTime = this.dayjs(this.form.dataRange[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
      Api.exportBikeSync(params)
        .then(res => {
          if (res.code === 200) {
            lookPDF(res.data)
          } else {
            this.$message.warning(res.message)
          }
        })
    },
    onBikeLogExport() {
      this.$refs['export-log'].onShowDialog()
    },
    handleCloseExportLog() {
      this.exportLegality = null
      this.checkedBrandIds = []
      this.$refs['export-log'].onCloseDialog()
    },
    onExportLog() {
      if (!this.checkedBrandIds.length) {
        this.$message.warning('请先选择品牌！')
        return
      }
      const params = {
        selfAreaId: this.selfAreaId,
        brandIds: this.checkedBrandIds.join(',')
      }
      if (this.exportLegality !== null) {
        params.legality = this.exportLegality
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Api.sitebikeOut(params).then((res) => {
        loading.close()
        this.$message({
          type: 'success',
          message: '数据导出成功！'
        })
        // 处理文件下载
        this.downloadFile(res, '车辆统计.xls')
        this.handleCloseExportLog()
      })
    },
    handleCheckAllChange(val) {
      this.checkedBrandIds = val ? this.brands.map(item => item.key) : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.brands.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.brands.length
    },
    downloadFile(content, fileName) {
      // 创建Blob对象
      const blob = new Blob([content])
      // 兼容性处理：判断浏览器是否支持 download
      if (this.isDownloadSupported()) {
        // 非IE浏览器
        const elink = document.createElement('a')
        elink.download = fileName
        const url = URL.createObjectURL(blob)
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        // 释放URL对象
        URL.revokeObjectURL(url)
        document.body.removeChild(elink)
      } else if (navigator.msSaveBlob) {
        // IE10及以上浏览器
        navigator.msSaveBlob(blob, fileName)
      } else {
        console.error('当前浏览器不支持文件下载')
      }
    },
    // 判断浏览器是否支持文件下载
    isDownloadSupported() {
      return 'download' in document.createElement('a')
    },
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        // 56: 导航栏高度修正
        // 79: table分页器高度修正
        this.tableViewHeight = window.innerHeight - 56 - H - 96 - 56
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .layout-header {
    margin: 16px;
    width: calc(98% - 20px);
  }
  .demo-form-inline{
    margin-top: 24px;
  }
  ::v-deep .el-table::before {
    left: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    height: 0.0625rem !important;
  }
   ::v-deep .el-table--border::after, .el-table--group::after, .el-table::before {
     content: '' !important;
     position: absolute !important;
     background-color: #EBEEF5 !important;
     z-index: 1 !important;
   }
</style>
